/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_RequiredInputs */

const en_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a preset.`)
};

const fr_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un préréglage.`)
};

const de_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Voreinstellung.`)
};

const it_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset.`)
};

const ru_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите предустановленный вариант.`)
};

const es_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un ajuste preestablecido.`)
};

const zh_cn2_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择一个预设。`)
};

const ja_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択してください。`)
};

const hi_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक प्रीसेट चुनें।`)
};

const pt_pt2_explorer_info_batch_pick_preset_required = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione uma predefinição.`)
};

/**
* | output |
* | --- |
* | "Please select a preset." |
*
* @param {Explorer_Info_Batch_Pick_Preset_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_required = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "de") return de_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "it") return it_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "ru") return ru_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "es") return es_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "ja") return ja_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "hi") return hi_explorer_info_batch_pick_preset_required(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_pick_preset_required(inputs)
	return en_explorer_info_batch_pick_preset_required(inputs)
});